import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId20: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/06/25/EU_quiraing_ex.jpg",
  },
  car: {
    driveAgeCheckbox: true,
  },
};
